import { render, staticRenderFns } from "./FamilyListItem.vue?vue&type=template&id=8bc07e3a&"
import script from "./FamilyListItem.vue?vue&type=script&lang=js&"
export * from "./FamilyListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports